import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Copy, Dropdown, Selector, Icon, themeColor } from '@elparking/components'
import { FormattedMessage } from 'react-intl'
import { isWebview } from '@elparking/utils'
import Routes from 'commons/js/routes/routes'
import styled from 'styled-components'
import { sendShowInvoicesEvent } from 'commons/js/services/sendMessage'
import { trackTealiumEvent, ViatShopEvents } from 'commons/js/services/analytics'

const DownloadButton = ({ uid, sendShowInvoicesEvent, isWebview, pageName }) => isWebview()
    ? <Button.bordered
        onClick={() => {
            trackTealiumEvent(ViatShopEvents.showInvoiceButtonEvent(pageName))
            sendShowInvoicesEvent()
        }}
        dataTest='download-invoice-button-webview'
        padding={['1px 5px', '1px 1em']}
        width='100%'>
        <Copy fontSize='xSmall' fontWeight='book' padding='0' color='inherit'>
            <FormattedMessage defaultMessage='Descargar factura' />
        </Copy>
    </Button.bordered>
    : <a rel='noopener noreferrer' href={Routes.viatInvoiceDownload({
        uid,
    })} target='_blank'>
        <Button.bordered dataTest='download-invoice-button' padding={['1px 5px', '1px 1em']} width='100%' onClick={() => trackTealiumEvent(ViatShopEvents.showInvoiceButtonEvent(pageName))}>
            <Copy fontSize='xSmall' fontWeight='book' padding='0' color='inherit'>
                <FormattedMessage defaultMessage='Descargar factura' />
            </Copy>
        </Button.bordered>
    </a>

DownloadButton.propTypes = {
    uid: PropTypes.string.isRequired,
    sendShowInvoicesEvent: PropTypes.func.isRequired,
    isWebview: PropTypes.func.isRequired,
    pageName: PropTypes.string,
}

const Option = ({ label, value }) => (
    <a rel='noopener noreferrer' href={Routes.viatInvoiceDownload({
        uid: value,
    })} target='_blank'>
        <Copy fontSize='xSmall' fontWeight='book' color='main' padding='0'>
            <FormattedMessage defaultMessage='Factura {label}' values={{ label }} />
        </Copy>
    </a>
)

Option.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
}

export { Option, DownloadButton }

const Container = styled(Selector)`
    border: 1px solid ${themeColor('main')};
`

const DownloadBlock = ({ invoices, isWebview, sendShowInvoicesEvent, pageName }) => {
    if (invoices.length === 0) {
        return null
    }
    return <Box width='180px'>
        {(invoices.length > 1) && !isWebview()
            ? <Dropdown
                onlyDesktop
                iconPlaceholderElement={() => <Icon type='arrow-down' color='main' />}
                selectorElement={Container}
                renderPlaceholder={() => <Copy padding='0' color='main' fontSize='xxSmall' fontWeight='book'>
                    <FormattedMessage defaultMessage='Descargar factura' />
                </Copy>}
                renderSelected={Option}
                renderOption={Option}
                options={
                  invoices.map(({ number: label, uid: value }) => ({ label, value }))
              }
                dataTest='download-invoice-dropdown'/>
            : <DownloadButton uid={invoices[0].uid} isWebview={isWebview} sendShowInvoicesEvent={sendShowInvoicesEvent} pageName={pageName} />
        }
    </Box>
}

DownloadBlock.defaultProps = {
    isWebview,
    sendShowInvoicesEvent,
}

DownloadBlock.propTypes = {
    isWebview: PropTypes.func,
    sendShowInvoicesEvent: PropTypes.func,
    invoices: PropTypes.arrayOf(PropTypes.shape({
        number: PropTypes.string,
        uid: PropTypes.string,
    })).isRequired,
    pageName: PropTypes.string,
}

export default DownloadBlock
